import { render } from "./assets-modal.vue?vue&type=template&id=235ece33"
import script from "./assets-modal.vue?vue&type=script&lang=js"
export * from "./assets-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__